import type {AuthService} from '@/domain/interfaces/AuthService';

export class GetCurrentUserUseCase {
  constructor(private readonly repository: AuthService) {}
  execute = async () => {
    return await this.repository.me();
  };
}
